export function SwitchArrowIcon(props) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 13.4444H1M1 13.4444L4.5 9.88889M1 13.4444L4.5 17M1 4.55556H15M15 4.55556L11.5 1M15 4.55556L11.5 8.11111"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
